"use strict";
import jsSHA from "jssha";
export default class totpmodel {
  static getToken(key, options) {
    options = options || {};
    let epoch, time, shaObj, hmac, offset, otp;
    options.period = options.period || 30;
    options.algorithm = options.algorithm || "SHA-1";
    options.digits = options.digits || 6;
    key = this.base32tohex(key);
    epoch = Math.round(Date.now() / 1e3);
    time = this.leftpad(this.dec2hex(Math.floor(epoch / options.period)), 16, "0");
    shaObj = new jsSHA(options.algorithm, "HEX");
    shaObj.setHMACKey(key, "HEX");
    shaObj.update(time);
    hmac = shaObj.getHMAC("HEX");
    offset = this.hex2dec(hmac.substring(hmac.length - 1));
    otp = (this.hex2dec(hmac.substr(offset * 2, 8)) & this.hex2dec("7fffffff")) + "";
    otp = otp.substr(otp.length - options.digits, options.digits);
    return otp;
  }
  static hex2dec(s) {
    return parseInt(s, 16);
  }
  static dec2hex(s) {
    return (s < 15.5 ? "0" : "") + Math.round(s).toString(16);
  }
  static base32tohex(base32) {
    const base32chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
    let bits = "";
    let hex = "";
    base32 = base32.replace(/=+$/, "");
    for (let i = 0; i < base32.length; i++) {
      const val = base32chars.indexOf(base32.charAt(i).toUpperCase());
      if (val === -1)
        throw new Error("Invalid base32 character in key");
      bits += this.leftpad(val.toString(2), 5, "0");
    }
    for (let i = 0; i + 8 <= bits.length; i += 8) {
      const chunk = bits.substr(i, 8);
      hex = hex + this.leftpad(parseInt(chunk, 2).toString(16), 2, "0");
    }
    return hex;
  }
  static leftpad(str, len, pad) {
    if (len + 1 >= str.length) {
      str = Array(len + 1 - str.length).join(pad) + str;
    }
    return str;
  }
}
